import { SxProps, Theme } from '@mui/material';

export const experienceSummaryStyles = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  }) as SxProps<Theme>,

  headerContainer: (theme: Theme) => ({
    flexShrink: 0,
  }) as SxProps<Theme>,

  tableContainer: (theme: Theme) => ({
    flexGrow: 1,
    overflow: 'auto',
  }) as SxProps<Theme>,

  exportMenuContainer: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
  }) as SxProps<Theme>,

  legendSection: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: theme.spacing(2),
  }) as SxProps<Theme>,

  legendWell: (theme: Theme) => ({
    display: 'inline-block',
    minHeight: 20,
    padding: '19px 0',
    marginBottom: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,0.05)',
    width: 'auto',
  }) as SxProps<Theme>,

  legendRow: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
  }) as SxProps<Theme>,

  legendItem: (theme: Theme) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(0.5),
    fontSize: 12,
    maxWidth: 100,
  }) as SxProps<Theme>,

  lastUpdated: (theme: Theme) => ({
    fontSize: 11,
    textAlign: 'center',
    width: '100%',
  }) as SxProps<Theme>,
};

export default experienceSummaryStyles;
